import { isLocal } from "../env";
import ameren_config from "./ameren";
import demo_config from "./demo";
import dlc_config from "./dlc";
import duke_config from "./duke";
import jea_config from "./jea";
import pge_config from "./pge";
import aep_config from "./aep";
import heco_config from "./heco";
import mb_config from "./mb";
import cnp_config from "./cnp";
import hecooutage_config from "./hecooutage";
const { REACT_APP_DEFAULT_CLIENT = "demo" } = process.env;

/**
 * @typedef {Object} ClientConfig
 * @property {Object} voice - Voice channel configurations
 * @property {object} [defaults] - Any default values that apply for the client
 * @property {Object} [disabled_features] - Which services should be disabled in the create campaign flow
 */

/**
 * Client level customizations
 * @return  {ClientConfig}
 */
export const client_config = (function () {
  let client;
  if (/eons\./.test(window.location.hostname)) {
    client = window.location.hostname.replace(/eons\..+/, "").toLowerCase();
  } else {
    client = window.location.hostname.split(".").shift().toLowerCase();
  }

  let config;
  switch (isLocal() ? REACT_APP_DEFAULT_CLIENT : client) {
    case "ameren":
      console.log('-- Client identified as "Ameren" --');
      config = ameren_config;
      break;

    case "dlc":
      console.log('-- Client identified as "DLC" --');
      config = dlc_config;
      break;

    case "duke":
      console.log('-- Client identified as "Duke" --');
      config = duke_config;
      break;

    case "jea":
      console.log('-- Client identified as "JEA" --');
      config = jea_config;
      break;

    case "demo":
    case "nexus":
      console.log('-- Client identified as "DEMO" --');
      config = demo_config;
      break;
    case "pge":
      console.log('-- Client identified as "PGE" --');
      config = pge_config;
      break;
    case "aep":
      console.log('-- Client identified as "AEP" --');
      config = aep_config;
      break;
    case "heco":
      console.log('-- Client identified as "HECO NORMAL DIVISION" --');
      config = heco_config;
      break;
    case "mb":
    case "mb-":
      console.log('-- Client identified as "MB INTERNAL" --');
      config = mb_config;
      break;
    case "hecooutage":
      console.log('-- Client identified as "HECO OUTAGE DIVISION" --');
      config = hecooutage_config;
      break;
    case "cnp":
      console.log('-- Client identified as "CENTRE POINT" --');
      config = cnp_config;
      break;
    default:
      throw new Error(`ENV: Unexpected Client from domain [${client}]`);
  }

  if (isLocal() && !config.disabled_features.voice) {
    console.log("-- Prepending Dev Options --");
    config.voice.caller_id_options.splice(1, null, {
      label: "Inbound Test: (225) 317-7676",
      value: "2253177676",
    });
  }

  return config;
})();
